import React from 'react';
import { VendorProvider } from './context/VendorContext';
import VendorList from './components/VendorList/VendorList';
import MessagePanel from './components/MessagePanel/MessagePanel';
import './App.css';

function App() {
  return (
    <VendorProvider>
      <div className="app-container">
        <VendorList />
        <MessagePanel />
      </div>
    </VendorProvider>
  );
}

export default App;